<template>
    <div id="paypal" v-if="!!datos">

        <div class="results animated zoomIn" v-if="paid">

            <template v-if="paid == 'success'">
                <img class="results-icon" src="./../assets/check.svg">
                <h2>Pedido pagado</h2>
                <p>Puedes cerrar ésta ventana.</p>
            </template>

            <template v-if="paid == 'fail'">
                <img class="results-icon" src="./../assets/fail.svg">
                <h2>No pudimos procesar el plago</h2>
                <p>Por favor intenta nuevamente con otro método de pago.</p>
            </template>

        </div>
        
        <div class="animated fadeInUp" v-else >
            <div class="center">
                <img class="logo" src="./../assets/logo.png">
            </div>

            <dl>
                <dt>Folio</dt><dd> {{datos.pedido_headers.folio}}</dd>
                <dt>Cliente</dt><dd>{{datos.usuario.nombre}} {{datos.usuario.apellidos}}</dd>
                <dt>Costo</dt><dd>{{datos.total | currency}}</dd>
            </dl>

            <div id="paypal-button-container"></div>

        </div>

    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    export default {
        data: ()=> {
            return {
                paid: null
            }
        },
        computed: {
            ...mapGetters({datos: 'readData', isLoaded: 'isLoaded'})
        },
        methods: {
            ...mapActions(['makePaid']),
            initPaypal(){
                paypal.Buttons({
                    createOrder: (data, actions) => {
                        let purchase_units = [{
                                amount: {
                                    "currency_code": "MXN",
                                    value: this.datos.total
                                }
                            }];
                        // This function sets up the details of the transaction, including the amount and line item details.
                        return actions.order.create({
                            purchase_units
                        });
                    },
                    onApprove: (data, actions) => {
                        // This function captures the funds from the transaction.
                        return actions.order.capture().then((details) => {
                            if(details.status == 'COMPLETED'){
                                this.makePaid( details )
                                    .then((response)=>{
                                        if(response.status)
                                            this.paid = 'success';
                                        else {
                                            this.paid = 'fail';
                                            alert('Ocurrió un error al registrar tu pago, por favor comunicate con Superasy')
                                        }
                                    })
                                    .catch(()=>{
                                        this.paid = 'fail';
                                        alert('Ocurrió un error de conexión al registrar tu pago, por favor comunicate con Superasy')
                                    })
                            } else {
                                this.paid = 'fail';
                            }
                        });
                    }
                }).render('#paypal-button-container')
            }
        },
        beforeMount(){
            if(!this.isLoaded){
                this.$router.push('/loading')
            }
        },
        mounted(){
            if(this.datos.pedido_headers.pagado == "0"){
                setTimeout(this.initPaypal, 500)
            } else if (this.datos.pedido_headers.pagado == "1") {
                this.paid = 'success'
            }
        }
    }
</script>

<style lang="less">
    #paypal {
        DL {
            width: 100%;
            display: flex;
            flex-flow: row;
            flex-wrap: wrap;
            DT {
                padding: 0.5em 0; margin: 0;
                text-align: right;
                flex: 1 0 30%;
                &:after {
                    content: ':';
                }
            }
            DD {
                padding: 0.5em 0; margin: 0;
                padding-left: 2em;
                text-align: left;
                flex: 1 0 calc(70% - 2em);
                font-weight: bold;
            }
        }
        .results {
            display: flex;
            flex-flow: column;
            align-items: center;

            &-icon {
                flex: 1;
                padding: 1em;
                max-width: 10em;
                width: 50vw;
            }
        }
        #paypal-button-container {
            padding: 1em;
        }
    } 
</style>


// WEBPACK FOOTER //
// src/components/Paypal.vue